"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExpandingCardMode;
(function (ExpandingCardMode) {
    /**
     * To have top compact card only
     */
    ExpandingCardMode[ExpandingCardMode["compact"] = 0] = "compact";
    /**
     * To have both top compact and bottom expanded card
     */
    ExpandingCardMode[ExpandingCardMode["expanded"] = 1] = "expanded";
})(ExpandingCardMode = exports.ExpandingCardMode || (exports.ExpandingCardMode = {}));
//# sourceMappingURL=ExpandingCard.Props.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/HoverCard/ExpandingCard.Props.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/HoverCard/ExpandingCard.Props.js
// module chunks = 1